import React from 'react';

import CompareBlock from './CompareBlock';
import SwapDeviceObject from './SwapDeviceObject';
import CompareArrow from './svgs/CompareArrow';

import { joinClass } from '../helpers/component';

const DeviceCompareBlock = ({
  device,
  device: { lob },
  className,
}) => (
  <CompareBlock className={joinClass(className)} svg={CompareArrow}>
    <SwapDeviceObject device={device} title="What you have" />
    <SwapDeviceObject
      title="What You'll Get"
      device={{
        lob,
        description: lob === 'video' ? 'New TV Box' : 'New Modem',
      }}
    />
  </CompareBlock>
);

export default DeviceCompareBlock;
